document.addEventListener("DOMContentLoaded", () => {
  const mount = document.getElementById("coffee-wizzard");
  if (!mount) return;

  try {
    // --------------------------------------------------
    // 1) Data
    // --------------------------------------------------
    const ALL_MACHINES = ["drip", "french-press", "percolator", "keurig", "espresso"];

    const PRODUCTS = [
      // Espresso-friendly / espresso-lovers
      {
        handle: "sweetblondcoffee",
        title: "Sweet Blond Espresso",
        roast: "light",
        origin: "blend",
        machines: ALL_MACHINES,
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "Bright, lively, and a great fit for espresso lovers who want something vibrant."
      },
      {
        handle: "6-bean-espresso",
        title: "6 Bean Espresso",
        roast: "dark",
        origin: "blend",
        machines: ALL_MACHINES,
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "Rich and bold with the deeper espresso profile many dark roast fans enjoy."
      },
      {
        handle: "decaf-peru-espresso",
        title: "Decaf Peru Espresso",
        roast: "dark",
        origin: "single-origin",
        machines: ALL_MACHINES,
        flavored: false,
        decaf: true,
        flavorType: null,
        notes: "A darker decaf option with fuller roast character that still works beautifully in regular coffee brewing."
      },

      // Dark roast options
      {
        handle: "italianroastcoffee",
        title: "Italian Roast",
        roast: "dark",
        origin: "blend",
        machines: ALL_MACHINES,
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "A deep, classic dark roast for people who like a stronger cup."
      },
      {
        handle: "cowboy-blend",
        title: "Cowboy Blend",
        roast: "dark",
        origin: "blend",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "Bold and hearty with a no-nonsense profile that works great in full-bodied brews."
      },

      // Medium classics
      {
        handle: "breakfast-blend",
        title: "Breakfast Blend",
        roast: "medium",
        origin: "blend",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "Balanced and dependable—an easy pick for someone who wants a smooth everyday cup."
      },
      {
        handle: "whiskey-barrel-aged",
        title: "Whiskey Barrel Aged",
        roast: "medium",
        origin: "single-origin",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "A more adventurous choice with a unique character for someone wanting something different."
      },
      {
        handle: "upland-bali-blue",
        title: "Upland Bali Blue",
        roast: "medium-dark",
        origin: "single-origin",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "Smooth and satisfying with a richer single-origin character that leans a little darker."
      },

      // Decaf medium
      {
        handle: "decaf-peru",
        title: "Decaf Peru",
        roast: "medium",
        origin: "single-origin",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: false,
        decaf: true,
        flavorType: null,
        notes: "A smooth medium roast decaf for someone who wants flavor without the caffeine."
      },

      // Flavored mediums
      {
        handle: "toasty-hazel-hazelnut",
        title: "Toasty Hazel Hazelnut",
        roast: "medium",
        origin: "blend",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: true,
        decaf: false,
        flavorType: "hazelnut-nutty",
        notes: "Warm and nutty with a cozy dessert-style feel."
      },
      {
        handle: "cinnafix-cinnabun",
        title: "Cinnafix Cinnabun",
        roast: "medium",
        origin: "blend",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: true,
        decaf: false,
        flavorType: "cinnamon-bakery",
        notes: "A sweet bakery-style coffee for people who want a cinnamon roll kind of vibe."
      },
      {
        handle: "vanilla-vibes-french-vanilla",
        title: "Vanilla Vibes (French Vanilla)",
        roast: "medium",
        origin: "blend",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: true,
        decaf: false,
        flavorType: "vanilla-smooth",
        notes: "Smooth and sweet with a familiar vanilla flavor that works for a lot of people."
      },
      {
        handle: "caramel-craze-caramel",
        title: "Caramel Craze (Caramel)",
        roast: "medium",
        origin: "blend",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: true,
        decaf: false,
        flavorType: "caramel-sweet",
        notes: "A sweet, mellow caramel option that fits people who enjoy dessert-style coffee."
      },

      // Light singles
      {
        handle: "peru-jungle-java",
        title: "Peru Jungle Java",
        roast: "light",
        origin: "single-origin",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "A brighter single-origin choice for someone who wants a lighter roast experience."
      },
      {
        handle: "chiapas-da-mexico",
        title: "Chiapas Da Mexico",
        roast: "light",
        origin: "single-origin",
        machines: ["drip", "french-press", "percolator", "keurig"],
        flavored: false,
        decaf: false,
        flavorType: null,
        notes: "A lighter single-origin pick with a clean, approachable profile."
      }
    ];

    const QUESTIONS = [
      {
        key: "caffeine",
        title: "Caffeine today?",
        options: [
          { value: "caffeinated", label: "Caffeinated" },
          { value: "decaf", label: "Decaf" },
          { value: "either", label: "Either / Surprise me" }
        ]
      },
      {
        key: "machine",
        title: "What are you brewing with?",
        options: [
          { value: "drip", label: "Drip Machine" },
          { value: "french-press", label: "French Press" },
          { value: "percolator", label: "Percolator" },
          { value: "keurig", label: "Keurig (Reusable Cup)" },
          { value: "espresso", label: "Espresso Machine" }
        ]
      },
      {
        key: "roast",
        title: "What roast do you enjoy?",
        options: [
          { value: "light", label: "Light" },
          { value: "medium", label: "Medium" },
          { value: "dark", label: "Dark" }
        ]
      },
      {
        key: "flavored",
        title: "Flavored coffee?",
        options: [
          { value: "yes", label: "Yes (dessert vibes)" },
          { value: "no", label: "No (keep it classic)" }
        ]
      },
      {
        key: "flavorProfile",
        title: "What flavor sounds best?",
        options: [
          { value: "cinnamon-bakery", label: "Cinnamon / Bakery" },
          { value: "vanilla-smooth", label: "Vanilla / Smooth" },
          { value: "caramel-sweet", label: "Caramel / Sweet" },
          { value: "hazelnut-nutty", label: "Hazelnut / Nutty" },
          { value: "surprise", label: "Surprise Me" }
        ]
      },
      {
        key: "origin",
        title: "Single-origin or blends?",
        options: [
          { value: "either", label: "Either / I don’t care" },
          { value: "single-origin", label: "Single-Origin" },
          { value: "blend", label: "Blend" }
        ]
      }
    ];

    // --------------------------------------------------
    // 2) Reactions
    // --------------------------------------------------
    function pickRandom(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function safeList(bucket) {
      const cfg = window.JNJ_WIZARD_IMAGES || {};
      const raw = (cfg[bucket] && cfg[bucket].length) ? cfg[bucket] : (cfg.react || []);
      return (raw || []).filter(url => typeof url === "string" && url.trim().length > 0);
    }

    function ensureReactionUI(quizBox) {
      if (quizBox.querySelector("#wizard-reaction-wrap")) return;

      const wrap = document.createElement("div");
      wrap.id = "wizard-reaction-wrap";
      wrap.innerHTML = `<img id="wizard-reaction-img" alt="Coffee Wizzard guide" />`;
      quizBox.prepend(wrap);
    }

    function preloadAllReactions() {
      const cfg = window.JNJ_WIZARD_IMAGES || {};
      ["welcome", "react", "results"].forEach(bucket => {
        (cfg[bucket] || []).forEach(url => {
          if (!url) return;
          const img = new Image();
          img.src = url;
        });
      });
    }

    function showReaction(quizBox, bucket = "react") {
      const list = safeList(bucket);
      if (!list.length) return;

      const img = quizBox.querySelector("#wizard-reaction-img");
      if (!img) return;

      const nextSrc = pickRandom(list);
      const currentSrc = img.getAttribute("src") || "";

      if (nextSrc === currentSrc && list.length === 1) return;

      const pre = new Image();
      pre.onload = () => {
        img.src = nextSrc;
        img.classList.remove("swap");
        requestAnimationFrame(() => img.classList.add("swap"));
      };
      pre.onerror = () => {};
      pre.src = nextSrc;
    }

    // --------------------------------------------------
    // 3) Dynamic question flow
    // --------------------------------------------------
    function getVisibleQuestions(answers) {
      if (answers.caffeine === "decaf") {
        return QUESTIONS.filter(q => q.key === "caffeine" || q.key === "roast");
      }

      if (answers.flavored === "yes") {
        return QUESTIONS.filter(q =>
          q.key === "caffeine" ||
          q.key === "machine" ||
          q.key === "roast" ||
          q.key === "flavored" ||
          q.key === "flavorProfile"
        );
      }

      if (answers.flavored === "no") {
        return QUESTIONS.filter(q =>
          q.key === "caffeine" ||
          q.key === "machine" ||
          q.key === "roast" ||
          q.key === "flavored" ||
          q.key === "origin"
        );
      }

      return QUESTIONS.filter(q =>
        q.key === "caffeine" ||
        q.key === "machine" ||
        q.key === "roast" ||
        q.key === "flavored"
      );
    }

    function getCurrentQuestion(answers, step) {
      const visibleQuestions = getVisibleQuestions(answers);
      return visibleQuestions[step] || null;
    }

    function getTotalSteps(answers) {
      return getVisibleQuestions(answers).length;
    }

    // --------------------------------------------------
    // 4) Matching logic
    // --------------------------------------------------
    function hardFilter(product, answers) {
      if (answers.caffeine === "decaf") {
        return product.decaf === true;
      }

      if (answers.caffeine === "caffeinated" && product.decaf) return false;

      if (answers.machine && !product.machines.includes(answers.machine)) return false;

      if (answers.flavored === "yes" && !product.flavored) return false;
      if (answers.flavored === "no" && product.flavored) return false;

      return true;
    }

    function addRoastScore(productRoast, desiredRoast, exactPoints, nearPoints) {
      if (productRoast === desiredRoast) return exactPoints;

      if (productRoast === "medium-dark") {
        if (desiredRoast === "dark") return exactPoints - 1;
        if (desiredRoast === "medium") return nearPoints;
      }

      if (productRoast === "medium" && desiredRoast === "dark") return nearPoints - 2;
      if (productRoast === "dark" && desiredRoast === "medium") return nearPoints - 2;
      if (productRoast === "medium" && desiredRoast === "light") return nearPoints - 2;
      if (productRoast === "light" && desiredRoast === "medium") return nearPoints - 2;

      return 0;
    }

    function scoreProduct(product, answers) {
      let score = 0;

      // --------------------------
      // Decaf path
      // --------------------------
      if (answers.caffeine === "decaf") {
        score += addRoastScore(product.roast, answers.roast, 20, 6);

        if (product.handle === "decaf-peru") score += 5;
        if (product.handle === "decaf-peru-espresso") score += 5;

        if (product.handle === "decaf-peru" && (answers.roast === "medium" || answers.roast === "light")) {
          score += 5;
        }

        if (product.handle === "decaf-peru-espresso" && answers.roast === "dark") {
          score += 6;
        }

        return score;
      }

      // --------------------------
      // Flavored path
      // --------------------------
      if (answers.flavored === "yes") {
        if (product.flavored) score += 10;

        // Roast is only a soft preference for flavored coffee
        score += addRoastScore(product.roast, answers.roast, 4, 3);

        if (
          answers.flavorProfile &&
          answers.flavorProfile !== "surprise" &&
          product.flavorType === answers.flavorProfile
        ) {
          score += 20;
        }

        if (answers.flavorProfile === "surprise") {
          score += 3;
        }

        if (answers.machine === "espresso") {
          score -= 2;
        }

        return score;
      }

      // --------------------------
      // Normal non-flavored path
      // --------------------------
      score += addRoastScore(product.roast, answers.roast, 8, 6);

      if (answers.origin === "single-origin") {
        if (product.origin === "single-origin") {
          score += 10;
        } else {
          score -= 4;
        }
      } else if (answers.origin === "blend") {
        if (product.origin === "blend") {
          score += 8;
        } else {
          score -= 2;
        }
      } else {
        score += 1;
      }

      if (answers.caffeine === "either" && !product.decaf) score += 1;

      if (answers.machine === "espresso") {
        if (product.handle === "sweetblondcoffee" && answers.caffeine !== "decaf") score += 6;
        if (product.handle === "6-bean-espresso" && answers.caffeine !== "decaf") score += 6;
      }

      if (answers.roast === "dark") {
        if (product.handle === "italianroastcoffee") score += 7;
        if (product.handle === "cowboy-blend") score += 6;
        if (product.handle === "6-bean-espresso" && answers.machine === "espresso") score += 5;
        if (product.handle === "upland-bali-blue") score += 3;
      }

      if (answers.roast === "light") {
        if (product.handle === "sweetblondcoffee") score += 6;
        if (product.handle === "peru-jungle-java") score += 5;
        if (product.handle === "chiapas-da-mexico") score += 5;
      }

      if (answers.roast === "medium") {
        if (product.handle === "breakfast-blend") score += 6;
        if (product.handle === "upland-bali-blue") score += 5;
        if (product.handle === "whiskey-barrel-aged") score += 4;
      }

      if (answers.origin === "single-origin") {
        if (product.handle === "upland-bali-blue") score += 3;
        if (product.handle === "whiskey-barrel-aged") score += 2;
        if (product.handle === "peru-jungle-java") score += 2;
        if (product.handle === "chiapas-da-mexico") score += 2;
      }

      return score;
    }

    function topMatches(answers, count = 3) {
      const filtered = PRODUCTS.filter(product => hardFilter(product, answers));

      const scored = filtered
        .map(product => ({
          ...product,
          score: scoreProduct(product, answers)
        }))
        .sort((a, b) => b.score - a.score);

      let picks = scored.slice(0, count);

      if (!picks.length) {
        if (answers.caffeine === "decaf") {
          picks = PRODUCTS
            .filter(product => product.decaf)
            .slice(0, count)
            .map(product => ({ ...product, score: 0 }));
        } else if (answers.flavored === "yes") {
          picks = PRODUCTS
            .filter(product => product.flavored && !product.decaf)
            .slice(0, count)
            .map(product => ({ ...product, score: 0 }));
        } else {
          const machineMatches = answers.machine
            ? PRODUCTS.filter(
                product =>
                  product.machines.includes(answers.machine) &&
                  !product.flavored &&
                  !product.decaf
              )
            : PRODUCTS.filter(product => !product.flavored && !product.decaf);

          const usablePool = machineMatches.length
            ? machineMatches
            : PRODUCTS.filter(product => !product.decaf);

          picks = usablePool.slice(0, count).map(product => ({ ...product, score: 0 }));
        }
      }

      return picks;
    }

    function getRecommendationLabel(index) {
      if (index === 0) return "Best Match";
      if (index === 1) return "Also a Great Fit";
      return "Another Good Option";
    }

    function buildResultIntro(answers) {
      if (answers.caffeine === "decaf") {
        if (answers.roast === "dark") {
          return "Based on what you picked, a darker decaf profile should fit you best. Here are your best matches.";
        }

        if (answers.roast === "medium") {
          return "Based on what you picked, a smooth medium roast decaf should be the best fit for you.";
        }

        return "Based on what you picked, here are the decaf options that should fit you best.";
      }

      if (answers.flavored === "yes") {
        const flavorMap = {
          "cinnamon-bakery": "a cinnamon bakery-style coffee",
          "vanilla-smooth": "a smooth vanilla-style coffee",
          "caramel-sweet": "a sweet caramel-style coffee",
          "hazelnut-nutty": "a warm hazelnut-style coffee",
          "surprise": "a flavored coffee"
        };

        if (answers.roast === "dark") {
          return `You picked a bolder profile, and while our flavored coffees lean medium roast, these are the closest matches for ${flavorMap[answers.flavorProfile] || "your taste"}.`;
        }

        if (answers.roast === "light") {
          return `You picked a lighter profile, and while our flavored coffees lean medium roast, these are the closest matches for ${flavorMap[answers.flavorProfile] || "your taste"}.`;
        }

        return `Based on what you picked, here are the flavored coffees that best match ${flavorMap[answers.flavorProfile] || "your taste"}.`;
      }

      const caffeineText =
        answers.caffeine === "caffeinated" ? "caffeinated" : "coffee";

      const roastText = answers.roast || "coffee";
      return `Based on what you picked, here are a few ${roastText} roast ${caffeineText} options that should fit you well.`;
    }

    // --------------------------------------------------
    // 5) Render
    // --------------------------------------------------
    function render() {
      mount.innerHTML = `
        <div id="quiz-box">
          <div id="progress"></div>
          <div id="question"></div>
          <div id="controls">
            <button id="back" type="button">Back</button>
          </div>
          <div id="result"></div>
        </div>
      `;

      const quizBox = mount.querySelector("#quiz-box");
      const progress = mount.querySelector("#progress");
      const question = mount.querySelector("#question");
      const result = mount.querySelector("#result");
      const backBtn = mount.querySelector("#back");

      ensureReactionUI(quizBox);
      preloadAllReactions();

      let step = 0;
      let answers = {};

      showReaction(quizBox, "welcome");

      function pruneAnswersForCurrentPath() {
        const visibleKeys = new Set(getVisibleQuestions(answers).map(q => q.key));
        Object.keys(answers).forEach(key => {
          if (!visibleKeys.has(key)) {
            delete answers[key];
          }
        });
      }

      function showStep() {
        pruneAnswersForCurrentPath();

        const q = getCurrentQuestion(answers, step);
        const totalSteps = getTotalSteps(answers);

        if (!q) {
          showResults();
          return;
        }

        progress.textContent = `Step ${step + 1} of ${totalSteps}`;
        backBtn.style.display = step === 0 ? "none" : "";
        result.innerHTML = "";

        question.innerHTML = `
          <h3>${q.title}</h3>
          ${q.options.map(option => `
            <label>
              <input
                type="radio"
                name="${q.key}"
                value="${option.value}"
                ${answers[q.key] === option.value ? "checked" : ""}
              >
              ${option.label}
            </label>
          `).join("")}
        `;
      }

      function showResults() {
        pruneAnswersForCurrentPath();

        const picks = topMatches(answers, 3);

        question.innerHTML = "";
        progress.innerHTML = "";
        backBtn.style.display = "none";

        showReaction(quizBox, "results");

        result.innerHTML = `
          <h3>Your Coffee Wizzard picks:</h3>
          <p style="margin: 0 0 14px; color: #333333; line-height: 1.45;">
            ${buildResultIntro(answers)}
          </p>
          <ol>
            ${picks.map((product, index) => `
              <li>
                <div style="font-size: 0.82rem; font-weight: 800; opacity: 0.8; margin-bottom: 4px;">
                  ${getRecommendationLabel(index)}
                </div>
                <strong>${product.title}</strong>
                <div style="margin-top: 6px; opacity: 0.92; line-height: 1.45;">
                  ${product.notes || ""}
                </div>
                <a class="wizard-shop-btn" href="/products/${encodeURIComponent(product.handle)}">
                  Shop Now →
                </a>
              </li>
            `).join("")}
          </ol>
          <button id="restart" type="button">Start Over</button>
        `;

        const restartBtn = result.querySelector("#restart");
        if (restartBtn) {
          restartBtn.addEventListener("click", () => render());
        }
      }

      function setAnswerAndAdvance() {
        const q = getCurrentQuestion(answers, step);
        if (!q) return;

        const selected = question.querySelector(`input[name="${q.key}"]:checked`);
        if (!selected) return;

        answers[q.key] = selected.value;
        pruneAnswersForCurrentPath();

        const totalSteps = getTotalSteps(answers);

        if (step < totalSteps - 1) {
          step += 1;
          showStep();
        } else {
          showResults();
        }
      }

      question.addEventListener("change", event => {
        const target = event.target;
        if (target && target.matches('input[type="radio"]')) {
          showReaction(quizBox, "react");
          setTimeout(setAnswerAndAdvance, 120);
        }
      });

      backBtn.addEventListener("click", () => {
        if (step === 0) return;
        step -= 1;
        showStep();
      });

      showStep();
    }

    render();
  } catch (err) {
    console.error("Coffee Wizzard crashed:", err);
    mount.innerHTML = `
      <div id="quiz-box">
        <h3>Wizzard hit a snag 😅</h3>
        <p style="opacity:.9">Check the browser console for details.</p>
        <button type="button" id="wizard-retry">Try Again</button>
      </div>
    `;

    const btn = document.getElementById("wizard-retry");
    if (btn) {
      btn.addEventListener("click", () => location.reload());
    }
  }
});